import React from 'react';
import TextField from 'apollo-react/components/TextField';
import FieldWrapper from '../../fields/FieldWrapper';

const HiddenFieldInput = ({
  id,
  label,
  placeholder,
  value,
  onChange,
  onBlur,
  helperText,
  showError,
  disabled,
  required,
  columnStyle,
  hasConditions,
}) => {
  if (hasConditions) {
    return (
      <FieldWrapper style={columnStyle}>
        <TextField
          id={id}
          name={id}
          label={label}
          placeholder={placeholder}
          value={value || ''}
          onChange={onChange}
          onBlur={onBlur}
          helperText={helperText}
          error={showError}
          disabled={disabled}
          required={required}
          fullWidth
        />
      </FieldWrapper>
    );
  }

  return <input type="hidden" id={id} name={id} value={value || ''} />;
};

export default HiddenFieldInput;
